import { useEffect, useState } from 'react'

import { pageAdsApi, type PageAdLayoutGroup, type PageAdPage } from '@/api/page-ads'

export function usePageAds(page: PageAdPage) {
  const [groups, setGroups] = useState<PageAdLayoutGroup[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    let cancelled = false
    setLoading(true)
    void pageAdsApi.list(page).then(
      (res) => {
        if (cancelled) return
        setGroups(res.groups ?? [])
        setLoading(false)
      },
      () => {
        if (cancelled) return
        setGroups([])
        setLoading(false)
      },
    )
    return () => {
      cancelled = true
    }
  }, [page])

  return { groups, loading }
}
